// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2wlOp","content":"App_content__1FYcs"};